import {apolloPlatformAxiosInstance as axiosInstance} from './apolloPlatformAxiosInstance';

/**
 * User settings API
 */

export const apiGetUserSettings = async () => {
  return await axiosInstance.get('settings/me/');
};

export const apiPutUserSettings = async (userSettings: UserSettings) => {
  console.log('putting settings!: ', userSettings);
  return await axiosInstance.put('settings/me/', userSettings);
};
